export const AddUser = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 8.5L12 8.5" stroke="currentColor" strokeLinecap="round" />
      <path d="M14.5 11L14.5 6" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M13 17C13 17 13 15 13 14C13 13 12 11 9 11C6 11 8 11 5 11C2 11 1 13 1 14C1 15 1 17 1 17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 9C9.20914 9 11 7.20914 11 5C11 2.79086 9.20914 1 7 1C4.79086 1 3 2.79086 3 5C3 7.20914 4.79086 9 7 9Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
